/**
 * 도메인 리스트 유틸리티 함수
 * Utility functions to generate domain value lists from Enum
 */

import Enum from "../../enum";

/**
 * Document status list
 * @returns {string[]} Array of document status values
 */
export const DOCUMENT_STATUS_LIST = Object.keys(Enum.BE_DOCUMENT_STATUS)
    .map((key) => Enum.BE_DOCUMENT_STATUS[key]);

/**
 * Timestamp status list
 * @returns {string[]} Array of timestamp status values
 */
export const TIMESTAMP_STATUS_LIST = Object.keys(Enum.BE_TIMESTAMP_STATUS)
    .map((key) => Enum.BE_TIMESTAMP_STATUS[key]);

/**
 * Watermark type list
 * @returns {string[]} Array of watermark type values
 */
export const WATERMARK_TYPE_LIST = Object.keys(Enum.BE_WATERMARK_TYPE)
    .map((key) => Enum.BE_WATERMARK_TYPE[key]);

/**
 * Viewer action list
 * @returns {string[]} Array of viewer action values
 */
export const VIEWER_ACTION_LIST = Object.keys(Enum.BE_VIEWER_ACTION)
    .map((key) => Enum.BE_VIEWER_ACTION[key]);

/**
 * Viewer status list (filtered)
 * @returns {string[]} Array of active and expired viewer statuses
 */
export const VIEWER_STATUS_LIST = [
    Enum.BE_VIEWER_STATUS.ACTIVE,
    Enum.BE_VIEWER_STATUS.EXPIRED,
];
